export default "__VITE_ASSET__DhZVWeg8__"